export default {
  countryCode: 'country_code',
  phoneNumber: 'phone_number',
  fullName: 'full_name',
  email: 'email',
  emailRequired: 'email_required',
  zipCode: 'zip_code',
  subjects: 'subjects',
  referer: 'referer',
  referredByUrl: 'referred_by_url',
  spells: 'spells',
  tutoringType: 'tutoring-type',
  timeToCall: 'time_to_call',
  dialerConsentAccepted: 'dialer_consent_accepted',
  page: 'page',
  password: 'password'
};



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/constants/field_names.js